import { ECHART_DATE_FORMAT, GMT_IST_DIFFERENCE, MOMENT_COMPLETE_TIME, MOMENT_DATE_TIME_FORMAT, Utils } from "@app/_helpers";
import { AlgoSymbolPosition } from "@app/_shared/providers/algowise-position-data/algo-symbol-position.model";
import { MarginBlocked } from "@app/_shared/providers/funds/funds.interface";
import { BriefPortfolioModel } from "@app/modules/trading/modules/market-place/providers/market-place/market-place.models";
import * as moment from "moment";
import { AffiliateFundsStrategyType } from "../structs/affiliate.structs";
import { PortfolioCreationType } from "@app/_shared/modules/portfolio-form/portfolio-form.enums";

export class AffiliateFundRow {
    dateUnix: number;
    date: string = null;
    clientId: string = null;
    clientName: string = null;
    ucc: string = null;
    strategyName: string = null;
    cash: number = null;
    adhoc: number = null;
    additional: number = null;
    marginUntilized: number = null;
    strategyStartTime: string = null;
    marginBlocked: number = null;
    strategyEndTime: string = null;
    marginUnblocked: number = null;
    positionObjects?: Map<string, Map<string, AlgoSymbolPosition>>;
    pnl = 0;
    symbolToSubscribe = new Set<string>();
    pancard: string;
    isStrategyWisePnl?: boolean;
    strategyType: string = AffiliateFundsStrategyType.CUSTOM;
    ubpc: string = null;
    rm: string = null;



    constructor(margin?: MarginBlocked, strategy?: BriefPortfolioModel, ucc?: { [key: string]: string[] }, strategyWisePnl?: number[]) {
        if (strategy) {
            this.fillStrategyDetails(strategy, ucc, strategyWisePnl);
        }

        if (margin) {
            this.fillMarginData(margin);
        }
    }

    fillMarginData(margin: MarginBlocked) {
        this.dateUnix = moment(margin.created_at['$date']).subtract(GMT_IST_DIFFERENCE).unix();
        this.date = moment(margin.created_at['$date']).subtract(GMT_IST_DIFFERENCE).format(ECHART_DATE_FORMAT);
        this.cash = +Utils.precisionUtil(margin.outstanding_cash, 2);
        // TODO: Check how to get adhoc
        this.adhoc = +Utils.precisionUtil(margin.outstanding_adhoc, 2);
        this.additional = +Utils.precisionUtil(margin.outstanding_additional, 2);
        this.marginUntilized = +Utils.precisionUtil(margin.margin_utilized, 2);
        this.marginBlocked = +Utils.precisionUtil(margin.amount, 2);
        this.marginUnblocked = +Utils.precisionUtil(margin.unblock_amount, 2);
        this.strategyStartTime = moment(margin.created_at['$date']).subtract(GMT_IST_DIFFERENCE).format(MOMENT_COMPLETE_TIME);
        this.strategyEndTime = margin.updated_at['$date'] && !margin.is_blocked ?
            moment(margin.updated_at['$date']).subtract(GMT_IST_DIFFERENCE).format(MOMENT_COMPLETE_TIME) : null;

    }

    fillStrategyDetails(strategy: BriefPortfolioModel, ucc: { [key: string]: string[] }, strategyWisePnl: number[]) {
        this.dateUnix = moment(strategy.deployed_on).unix();
        this.date = moment(strategy.deployed_on).format(ECHART_DATE_FORMAT);
        this.strategyStartTime = moment(strategy.deployed_on).format(MOMENT_COMPLETE_TIME);
        this.strategyEndTime = strategy.terminatedAt ? moment(strategy.terminatedAt).format(MOMENT_COMPLETE_TIME) : null;

        this.strategyName = strategy.portfolioName;
        this.clientId = strategy.deployer;
        this.ucc = ucc && ucc[strategy.deployer] ? ucc[strategy.deployer][0]?.trim() : null;
        this.pancard = ucc && ucc[strategy.deployer] ? ucc[strategy.deployer][1]?.trim() : null;
        this.clientName = ucc && ucc[strategy.deployer] ? ucc[strategy.deployer][2]?.trim() : null;

        // In case of old strategies, we need to assign old pnl just once after applying precision, we don't have to update it again
        this.isStrategyWisePnl = !!strategyWisePnl?.length;
        if (this.isStrategyWisePnl) {
            this.pnl = Utils.applyPrecision(strategyWisePnl[0]);
        } else {
            this.pnl = null;
        }

        if ((strategy.portfolioCreationType === PortfolioCreationType.Copy) && strategy.originalPortfolioDetails?.length) {
            this.strategyType = strategy.originalPortfolioDetails[0].isPublic ? AffiliateFundsStrategyType.ORIGINAL : AffiliateFundsStrategyType.CUSTOM;
        } else {
            this.strategyType = strategy.isPublic ? AffiliateFundsStrategyType.ORIGINAL : AffiliateFundsStrategyType.CUSTOM;
        }

    }

    updatePnl() {

        if (this.isStrategyWisePnl && this.pnl) {
            return this.pnl;
        }
        this.pnl = this.isStrategyWisePnl ? this.pnl : 0;
        if (this.positionObjects) {
            this.addSymbols();
        }

        if (!this.isStrategyWisePnl) {
            this.pnl = Utils.applyPrecision(this.pnl);
        }

        return this.pnl;
    }

    addSymbols() {
        this.positionObjects.forEach((el) => {
            el.forEach((key) => {
                this.pnl += key.totalPL;
                this.symbolToSubscribe.add(Utils.getJoinedString(key.market_id, key.security_id))
            });
        })
    }
}
